module.exports = __webpack_public_path__ + "static/media/shape_E.4be6f7bf.glb";